module.exports = __webpack_public_path__ + "img/duplicate.25e0ad88.svg";